import { getApiData } from '.';
import { BEJobStatus } from '../types/booking';
import { Booking } from '../types/store';

export const getInitBookingData = () => {
  const output: Booking = {
    staticBookingDetailsContainer: getApiData(),
    dynamicBookingDetailsContainer: getApiData(),
    paymentHistoryContainer: getApiData(),
    referralCodeContainer: getApiData(),
  };

  return output;
};

export const getTimelineData = (
  status: BEJobStatus,
  createdAt,
  valetName,
  photos = [],
  isPaid = false,
  currentStatus: BEJobStatus,
  action = 'STATUS_CHANGE'
) => {
  if (action === 'STATUS_CHANGE') {
    switch (status) {
      //order of OR condition matters here
      case BEJobStatus.Created:
        return {
          title: 'Booking Created',
          content: 'Valet booking has been successfully created.',
          time: createdAt,
        };
      case BEJobStatus.PickAssigned: {
        return {
          title: 'Car Received',
          content: `We've received your car at the valet desk.`,
          time: createdAt,
        };
      }
      case BEJobStatus.PickAccepted: {
        return {
          title: 'Driver Assigned',
          content: `Valet ${
            valetName ?? ''
          } is assigned to park your car. He will park your car shortly.`,
          time: createdAt,
        };
      }
      case BEJobStatus.PickPicked: {
        return {
          title: 'Car Picked-up',
          content: `Valet ${
            valetName ?? ''
          } is now driving your car to the parking location.`,
          time: createdAt,
        };
      }
      case BEJobStatus.PickParked:
      case BEJobStatus.PickKeySubmitted: {
        return {
          title: 'Car parked',
          content:
            photos?.length > 0
              ? 'Click to see how your car is parked'
              : `Valet ${
                  valetName ?? ''
                } has safely parked your car. You can request to call your car back anytime using Get My Car.`,
          time: createdAt,
          carImages: photos,
        };
      }
      case BEJobStatus.DropRequest: {
        {
          return {
            title: 'Get My Car Requested',
            content:
              "We've received your request to bring your car back to the valet desk. Hold on while we assign a valet for this booking.",
            time: createdAt,
            isPaid,
            createdAt,
          };
        }
      }
      case BEJobStatus.DropAssigned: {
        return {
          title: 'Driver Assigned',
          content: `Valet ${
            valetName ?? ''
          } has been assigned to bring your car back to the valet desk.`,
          time: createdAt,
          isPaid,
          createdAt,
        };
      }
      case BEJobStatus.DropAccepted: {
        return {
          title: 'Valet On Their Way',
          content: `Valet ${
            valetName || ''
          } is on the way to pick your car from the parking location.`,
          time: createdAt,
        };
      }

      case BEJobStatus.DropPicked: {
        return {
          title: 'Valet Bringing Your Car',
          content: `Valet ${valetName} have picked your car and is on the way to bring it back to the valet desk.`,
          time: createdAt,
        };
      }
      case BEJobStatus.DropKeyReturned: {
        return {
          title: 'Car Arrived At Valet Desk',
          content:
            'Your car is waiting for you at our valet desk. You can now collect your car keys.',
          time: createdAt,
        };
      }
      case BEJobStatus.DropDelivered: {
        return {
          title: 'Car Delivered Successfully',
          content: `We have successfully delivered your car. We can't wait to serve you again!`,
        };
      }
    }
  }
};

export const getTimestamp = (data: any, status: BEJobStatus) => {
  if (data) {
    const index = data?.findIndex((item: any) => item.new_status === status);
    if (index !== -1) {
      return data[index].created_at;
    }
    return null;
  }
  return null;
};

export const BE_PICK_JOB_STATUS = [
  BEJobStatus.Prebooked,
  BEJobStatus.Created,
  BEJobStatus.PickAssigned,
  BEJobStatus.PickAccepted,
  BEJobStatus.PickPicked,
  BEJobStatus.PickParked,
  BEJobStatus.PickKeySubmitted,
];

export const isPickJob = (status: BEJobStatus) =>
  BE_PICK_JOB_STATUS.includes(status);

export const isDropJob = (status: BEJobStatus) => {
  let output = false;
  if (status) {
    output = !BE_PICK_JOB_STATUS.includes(status);
  }

  return output;
};

export const isCarDelivered = (status: BEJobStatus) =>
  [BEJobStatus.DropDelivered, BEJobStatus.Rated, BEJobStatus.Tipped].includes(
    status
  );
